<template>
    <v-container>
      <v-row>
          <v-col cols="12" md="7">
              <BlobFeed></BlobFeed>
          </v-col>
          <v-col cols="12" offset-md="1" md="4">
              <RadarList></RadarList>
          </v-col>
      </v-row>
      <v-row>
        <v-col>
          <BlobSuggestionCarousel></BlobSuggestionCarousel>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
  import BlobFeed from '../components/Feed/BlobFeed'
  import RadarList from '../components/radar/RadarList'
  import BlobSuggestionCarousel from '@/components/Blob/Suggestion/BlobSuggestionCarousel'

  export default {
    name: 'Dashboard',
    components: { BlobSuggestionCarousel, RadarList, BlobFeed },
  }
</script>

<style scoped>

</style>
